const LocalMethods = {
  methods: {
    async running_submit(format) {
      let headers = this.table_headers;
      let totals = this.$refs.advanced_search.totals;
      let params = this.$refs.advanced_search.local_params;
      this.loader(true);
      try {
        const response = await this.post(this.rest_api, {
          headers,
          totals,
          format,
          module_name: this.module_name,
          report_format_name: this.report_format_name,
          report_custom_name: this.report_name,
          total: this.$refs.advanced_search.pagination.total,
          exporting: true,
          timestamp: this.getCurrentDateTime(),
          sort_column: params.sort_column ? params.sort_column : "",
          sort_type: params.sort_type ? params.sort_type : "",
          ...this.form_data,
        });
        if (response.status) {
          if (response.data.is_queue) {
            this.notyfMesg(
              "Given you are generating a report with many records, you will get notified when the report is ready to download."
            );
          } else {
            this.download(response);
          }
        } else {
          this.error_handling(response);
        }
      } catch (error) {
        console.error("Error generating report:", error);
        // Handle the error scenario, show error messages, etc.
      }
      this.loader();
    },
    async download(response = {}) 
    {
      const data = response.data
      const fileExtension = data.url.split('.').pop().toLowerCase();

      let contentType;

      if (fileExtension === 'pdf') 
      {
        contentType = 'application/pdf';
      } 
      else if (fileExtension === 'xlsx' || fileExtension === 'xls') 
      {
        contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } 
      else if (fileExtension === 'csv') 
      {
        contentType = 'text/csv';
      } 
      else 
      {
        this.notyfMesg('Unsupported file type', 'error');
      }

      const base64Data = `data:${contentType};base64,${data.base64_file}`;

      const blob = this.base64ToBlob(base64Data);

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = data.url;
      link.click();
    },

    base64ToBlob(base64Data) {
      try 
      {
          const dataUrlRegex = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-+.]+)?;base64,(.+)$/;
          const matches = base64Data.match(dataUrlRegex);
      
          if (!matches) 
          {
            throw new Error('Invalid base64 data URL format');
          }
      
          const [, contentType, base64] = matches;
      
          const byteCharacters = atob(base64);
          const byteArrays = new Uint8Array(byteCharacters.length);
      
          for (let i = 0; i < byteCharacters.length; i++) 
          {
            byteArrays[i] = byteCharacters.charCodeAt(i);
          }
    
          return new Blob([byteArrays], { type: contentType });
        } 
        catch (error) 
        {
          console.error('Error converting base64 to blob:', error);
          throw error;
        }

    },


    orderRequest(event) {
      this.table_headers = event;
    },
    async save() {
      let headers = this.table_headers;
      let totals = this.$refs.advanced_search.totals;
      let params = this.$refs.advanced_search.local_params;

      const request = {
        field_columns: headers,
        total_columns: totals,
        filter_columns: this.form_data,
        module_name: this.module_name,
        name: this.report_name,
        order_field: params.sort_column ? params.sort_column : "",
        order_by: params.sort_type ? params.sort_type : "",
        id: this.id,
      };

      const response = await this.post(this.rest_api_reports, request);

      if (response.status) {
        this.id = response.data.data.id;
        let route = `/new-reports/${this.id}`;
        this.$router
          .replace({
            path: route,
          })
          .catch(() => {});

        this.notyfMesg("Reports saved successfully");
      } else {
        this.error_handling(response);
      }
    },
  },

  save() {
    this;
  },
};

export default LocalMethods;